export default __webpack_public_path__ + "static/media/statistics.ba8dd8aa.svg";